export function getTourV2OfferCacheKey(offerId: string, privateRequestKey?: string, allPackages?: boolean): string {
  const baseKey = privateRequestKey ? `${offerId}-${privateRequestKey}` : offerId
  return allPackages ? `${baseKey}-allPackages` : baseKey
}
